import { render, staticRenderFns } from "./my-gig.page.vue?vue&type=template&id=1c6fcc22&scoped=true&"
import script from "./my-gig.page.vue?vue&type=script&lang=js&"
export * from "./my-gig.page.vue?vue&type=script&lang=js&"
import style0 from "./my-gig.page.vue?vue&type=style&index=0&id=1c6fcc22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6fcc22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
